import type { SVGProps } from 'react';

const SatelliteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_30121_51304)">
      <path
        d="M15.7501 10.5H17.2501C17.2501 14.2275 14.2276 17.25 10.5001 17.25V15.75C13.4026 15.75 15.7501 13.4025 15.7501 10.5ZM10.5001 12.75V14.25C12.5701 14.25 14.2501 12.57 14.2501 10.5H12.7501C12.7501 11.745 11.7451 12.75 10.5001 12.75ZM13.6951 0.442544L16.3501 3.09754C16.9351 3.68254 16.9351 4.63504 16.3501 5.22004L13.9651 7.60504C13.3801 8.19004 12.4276 8.19004 11.8426 7.60504L10.9126 6.67504L10.3801 7.20004L11.3101 8.13004C11.8951 8.71504 11.8951 9.66754 11.3101 10.2525L10.2526 11.31C9.66759 11.895 8.71509 11.895 8.13009 11.31L7.20009 10.38L6.66759 10.9125L7.59759 11.8425C8.18259 12.4275 8.18259 13.38 7.59759 13.965L5.21259 16.35C4.62759 16.935 3.67509 16.935 3.09009 16.35L0.435088 13.695C-0.149912 13.11 -0.149912 12.1575 0.435088 11.5725L2.82009 9.18754C3.40509 8.60254 4.35759 8.60254 4.94259 9.18754L5.87259 10.1175L6.40509 9.58504L5.47509 8.66254C4.89009 8.07754 4.89009 7.12504 5.47509 6.54004L6.54009 5.47504C7.12509 4.89004 8.07759 4.89004 8.66259 5.47504L9.59259 6.40504L10.1251 5.87254L9.18759 4.95004C8.60259 4.36504 8.60259 3.41254 9.18759 2.82754L11.5726 0.442544C12.1651 -0.149956 13.1101 -0.149956 13.6951 0.442544ZM2.29509 11.8425L1.50009 12.6375L4.15509 15.2925L4.95009 14.4975L2.29509 11.8425ZM3.88509 10.2525L3.09009 11.0475L5.74509 13.7025L6.54009 12.9075L3.88509 10.2525ZM7.59759 6.54004L6.54009 7.59754L9.19509 10.2525L10.2526 9.19504L7.59759 6.54004ZM11.0476 3.09004L10.2526 3.88504L12.9076 6.54004L13.7026 5.74504L11.0476 3.09004ZM12.6376 1.50004L11.8426 2.29504L14.4976 4.95004L15.2926 4.15504L12.6376 1.50004Z"
        fill={props?.fill ?? '#696F88'}
      />
    </g>
    <defs>
      <clipPath id="clip0_30121_51304">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SatelliteIcon;
